import React from 'react';
import { useFlipOIDC } from './FlipOIDC';

interface FlipProfilePhotoProps {
  id?: string;
  firstName: string;
  lastName: string;
}

export default function FlipProfilePhoto({ id, firstName, lastName }: FlipProfilePhotoProps) {
  const { token } = useFlipOIDC();

  const style = {
    backgroundImage: `url(/api/v2/user/${id}/profile-photo?accessToken=${token})`,
  };

  return (
    <div className="flip-profile-photo">
      <div className="flip-profile-photo-text">
        {`${firstName.charAt(0).toUpperCase()}${lastName.charAt(0).toUpperCase()}`}
      </div>
      <div className="flip-profile-photo-img" style={style} />
    </div>
  );
}
